import React, { Fragment, useMemo } from "react"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table } from "reactstrap"
import { DefaultColumnFilter } from "../../Components/filters"
import TableBody from "./TableBody"
import TableFooter from "./TableFooter"
import TableHead from "./TableHead"
import TablePagination from "./TablePagination"

const TableContainer = ({
  columns,
  data,
  onHeaderClick,
  customPageSize,
  totalCount,
  widthControl,
  isMobile,
  footeraddition,
  tableheadShow,
  onPageChange,
  tableHeader,
  pageNumber,
  onClick,
  isSorting,
  setExpandedRow,
  onPageSizeChange,
}) => {
  const hiddenColumns = useMemo(() => {
    const hidden = []
    columns.forEach(el => {
      if (el?.hidden === true) {
        hidden.push(el.accessor)
      }
    })
    return hidden
  }, [columns])

  const pageCount = customPageSize === 0 ? 1 : Math.ceil(totalCount / customPageSize)

  const canPreviousPage = pageNumber > 0;
  const canNextPage = pageNumber < pageCount - 1;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    footerGroups,
  } = useTable(
    {
      columns,
      data,
      onHeaderClick: Function,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: pageNumber,
        pageSize: customPageSize,
        hiddenColumns: hiddenColumns,
      },
      manualPagination: true,
      manualSortBy: false,
      pageCount: pageCount,
      disableSortRemove: true,
      columnVisibility: { hidden: false },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const generateSortingIndicator = column => {
    return (
      column.sort && (
        <i
          className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}
        ></i>
      )
    )
  }

  return (
    <Fragment>
      <div className={`${onClick && "table-responsive"} react-table`}>
        <Table bordered hover {...getTableProps()}>
          <TableHead
            headerGroups={headerGroups}
            onHeaderClick={onHeaderClick}
            generateSortingIndicator={generateSortingIndicator}
            widthControl={widthControl}
            tableHeader={tableHeader}
            setExpandedRow={setExpandedRow}
          />
          {(page || []).length > 0 && footeraddition && (
            <TableFooter isMobile={isMobile} footerGroups={footerGroups} />
          )}
          <TableBody
            page={
              (page || []).map((data, index) => {
                data.id = String(index);
                data.index = index;
                data.original.index = index;
                return data;
              })}
            getTableBodyProps={getTableBodyProps}
            tableheadShow={tableheadShow}
            expandedRow={false}
            headerGroups={headerGroups}
            prepareRow={prepareRow}
            columns={columns}
            data={data}
            isMobile={isMobile}
          />
        </Table>
        <TablePagination
          pageNumber={pageNumber}
          pageCount={pageCount}
          onPageChange={onPageChange}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          isSorting={isSorting}
          pageSize={customPageSize}
          data={data}
          totalCount={totalCount}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </Fragment>
  )
}

export default TableContainer
